const WorkOrderReport = () => import("@/views/user/work-order-report/index.vue")
const FormWorkOrderReport = () => import("@/views/user/work-order-report/form.vue")
const ViewWorkOrderReport = () => import("@/views/user/work-order-report/view.vue")
const ViewWorkOrderReportActivity = () => import("@/views/user/work-order-report/activity/view.vue")

export default {
    path: "/work-order",
    name: "work-order",
    meta: { title: "Work Order Report Management", authRequired: true },
    children: [
        {
            path: "",
            name: "work-order-report-index",
            component: WorkOrderReport,
            meta: { title: "Work Order Report ", description: "Work Order Report adalah proyek teknis yang dapat dihubungkan ke Issue, Program Maintenance, ataupun penambahan Manual.",authRequired: true },
        },
        {
            path: "create",
            name: "work-order-report-create",
            component: FormWorkOrderReport,
            meta: { title: "Tambah Work Order Report", description: "Work Order Report",action:"Tambah Data",authRequired: true },
        },
        {
            path: "edit/:id",
            name: "work-order-report-edit",
            component: FormWorkOrderReport,
            meta: { title: "Edit Work Order Report", description: "Work Order Report",action:"Edit Data",authRequired: true },
        },
        {
            path: "view/:id",
            name: "work-order-report-view",
            component: ViewWorkOrderReport,
            meta: { title: "View Work Order Report", description: "Work Order Report",action:"View Data",authRequired: true },
        },
        {
            path: "activity/view/:id",
            name: "work-order-report-activity-view",
            component: ViewWorkOrderReportActivity,
            meta: { title: "View Activity", description: "Work Order Report", action: 'View Activity', authRequired: false },
        },
    ]
}